/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Container from "../../components/common/container/Container";
import {
  DEBI_ADD_PARTS_MSG,
  DEBI_AGREEMENT_ACCEPTANCE_TEXT,
  DEBI_AGREEMENT_MSG,
  DEBI_DETAILS_MSG,
  DEBI_PARTS_MSG,
  DEBI_PROCESS_APPROVE_MSG,
  DEBI_REQ_SIG,
  DEBI_REQ_SIG_TEXT,
  DEBI_SIGN_MSG,
  INSTALLER_INFO_MSG,
  INSTALLER_MSG,
  DEBI_ROLE,
  VALIDATIONS,
  SOURCE,
  ADD_PARTS,
  UPDATE_PARTS,
  DELETE_PART,
  COOKIE_KEY,
  DECRYPT_KEY,
  COLOR_RED,
  DISPLAY_FLEX,
  DEBI_DETAILS_GRIDITEN_STYLE,
  COLOR_GREEN,
  EDIT,
} from "../../utils/constants/GlobalConstants";
import { DEBI_DETAILS } from "../../utils/routes/Routes";
import {
  AppH5Header,
  AppH6Header,
} from "../../components/common/appHeaders/AppHeaders";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DebiDetailsInfo from "../../components/debiDetails/DebiDetailsInfo";
import GridContainer from "../../components/common/grid/GridContainer";
import GridItem from "../../components/common/grid/GridItem";
import ButtonLayout from "../../components/common/button/ButtonLayout";
import AgreementInput from "../../components/debiDetails/AgreementInput";
import SignaturesInput from "../../components/debiDetails/SignaturesInput";
import {
  AGREEMENT_INPUT_FORM,
  PROCESSING_INFO,
  STATUS,
} from "../../utils/constants/GlobalFormConstants";
import DataTable from "../../components/common/dataTable/DataTable";

import { useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import DataList from "../../components/common/dataList/DataList";
import DialogView from "../../components/common/dialogView/DialogView";
import AddNewParts from "../../components/debiDetails/AddNewParts";
import DeleteFunctionality from "../../components/debiDetails/DeleteFunctionality";
import {
  updateDebi,
  fetchDebiDetails,
  submitDebi,
  deleteDebi,
  cancelDebi,
  createDebi,
  editDebi,
  fetchRevisionNumber,
} from "../../services/debiServices";
import SimpleSnackbar from "../../components/common/snackbar/Snackbar";
import SimpleBackdrop from "../../components/common/backdrop/Backdrop";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { getUserName, getUserEmail } from "../../services/userService";
import CancelDebi from "../../components/debiDetails/CancelDebi";
import { createQuantityPart } from "../../services/partServices";
import EditDebi from "../../components/debiDetails/EditDebi";
import SubmitDebi from "../../components/debiDetails/SubmitDebi";
import ReviseDebi from "../../components/debiDetails/ReviseDebi";

const DebiDetails = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const [debiDetails, setDebiDetails] = useState(null);
  const [openPart, setOpenPart] = React.useState(false);
  const [clickDel, setClickDel] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [totalQuantity, setTotlaQuantity] = useState(null);
  const [selectedPart, setSelectedPart] = useState("");
  const [apiError, setApiError] = useState({ val: false, messages: "" });
  const [selectedDetails, setSelectedDetails] = useState(null);
  const [header, setHeader] = useState(ADD_PARTS);
  const [username, setUsername] = React.useState("");
  const [message, setMessage] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  // const [installerName, setInstallerName] = useState("");
  const [errorMessages, setErrorMessages] = useState({});
  const [validationMsgs, setValidationMsgs] = React.useState([]);
  const [emailError, setEmailError] = useState("");
  const [qtyErrorMsg, setQtyErrorMsg] = useState("");
  const [remainingFields, setRemainingFields] = React.useState({
    installerBusinessName: "",
    dcName: "",
    dcEmail: "",
    storeAgent: "",
    storeAgentEmail: "",
    salesRepName: "",
  });
  const [partRows, setPartsRows] = useState(null);
  const [openDebiDelete, setOpenDebiDelete] = useState(false);
  const [openCancelDebi, setOpenCancelDebi] = useState(false);
  const [openEditDebi, setOpenEditDebi] = useState(false);
  const [openSubmitDebi, setOpenSubmitDebi] = useState(false);
  const [openReviseDebi, setOpenReviseDebi] = useState(false);
  const [editClicked, setEditClicked] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme?.breakpoints?.down("sm"));
  const encryptF = Cookies.get(COOKIE_KEY);
  const navigate = useNavigate();

  useEffect(() => {
    if (encryptF) {
      const bytes = CryptoJS.AES.decrypt(encryptF, DECRYPT_KEY);
      const decryptData = JSON.parse(bytes?.toString(CryptoJS.enc.Utf8));
      decryptData && setUsername(decryptData.name);
      const role = decryptData.group;
      setIsEditable(
        role === DEBI_ROLE.SALES_REP || role === DEBI_ROLE.PARTS_ADMIN
      );
      setIsAdmin(
        role === DEBI_ROLE.SALES_REP || role === DEBI_ROLE.PARTS_ADMIN
      );
    }
  }, [encryptF]);

  const fetchDetails = async () => {
    if (state && id) {
      setLoader(true);
      try {
        const response = await fetchDebiDetails(state, id);
        setLoader(false);
        setRemainingFields({
          dcName: response?.debis[0]?.dcName || "",
          dcEmail: response?.debis[0]?.dcEmail || "",
          storeAgent: response?.debis[0]?.storeAgentName || "",
          storeAgentEmail: response?.debis[0]?.storeAgentEmail || "",
          installerBusinessName: response?.debis[0]?.installerBusinessName || ""
        });
        setDebiDetails(response);
        // setInstallerName(response?.debis[0]?.installerBusinessName);
        setPartsRows(response?.partDetails?.reverse());
        getTotalQty(response?.partDetails);
      } catch (error) {
        setApiError((val) => ({ ...val, val: true, message: error.message }));
        setLoader(false);
      }
    }
  };
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    fetchDetails();
  }, [state, id]);

  useEffect(() => {
    if (state && state.craetedebiFlag) setDebiDetails(state?.dataToDetails);
    // setInstallerName(state?.dataToDetails?.debis[0]?.installerBusinessName);
  }, [state]);

  const handleFieldChange = (key, value) => {
    setRemainingFields((prev) => ({ ...prev, [key]: value }));
  };
  const handleCloseParts = () => {
    setOpenPart(false);
    setClickDel(false);
  };
  const onPressAdd = () => {
    setHeader(ADD_PARTS);
    setOpenPart(true);
  };

  const validateSignatureFields = () => {
    const newErrors = {};
    var mailFormat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    var mailMAtchDC = mailFormat.test(remainingFields.dcEmail);
    var mailMAtchStore = mailFormat.test(remainingFields.storeAgentEmail);
    if (
      remainingFields.installerBusinessName &&
      remainingFields.installerBusinessName.length > 60
    ) {
      newErrors.installerBusinessName = VALIDATIONS.INSTALLER_NAME_LENGTH;
    }
    if (remainingFields.dcName && remainingFields.dcName.length > 60) {
      newErrors.dcName = VALIDATIONS.DC_NAME_LENGTH;
    }
    if (remainingFields.dcEmail && remainingFields.dcEmail.length > 60) {
      newErrors.dcEmail = VALIDATIONS.DC_EMAIL_LENGTH;
    } else if (remainingFields.dcEmail && !mailMAtchDC) {
      newErrors.dcEmail = VALIDATIONS.DC_EMAIL_VALID;
    }
    if (remainingFields.storeAgent && remainingFields.storeAgent.length > 60) {
      newErrors.storeAgent = VALIDATIONS.STORE_AGENT_LENGTH;
    }
    if (
      remainingFields.storeAgentEmail &&
      remainingFields.storeAgentEmail.length > 60
    ) {
      newErrors.storeAgentEmail = VALIDATIONS.STORE_AGENT_EMAIL;
    } else if (remainingFields.storeAgentEmail && !mailMAtchStore) {
      newErrors.storeAgentEmail = VALIDATIONS.STORE_AGENT_EMAIL_VALID;
    }

    if (
      remainingFields?.storeAgentEmail?.toUpperCase() ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() &&
      remainingFields?.dcEmail ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() &&
      debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        remainingFields?.storeAgentEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch =
          VALIDATIONS.DC_STORE_SALESREP_INSTALLER_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.storeAgentEmail?.toUpperCase() ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() &&
      remainingFields?.dcEmail?.toUpperCase() ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        remainingFields?.storeAgentEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.DC_STORE_INSTALLER_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.dcEmail?.toUpperCase() ===
      remainingFields?.storeAgentEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        remainingFields?.storeAgentEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.DC_STORE_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.dcEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.installerEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.DC_INSTALLER_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.storeAgentEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.installerEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.storeAgentEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.STORE_INSTALLER_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.storeAgentEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.salesRepEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.storeAgentEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.SALEREP_STORE_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.dcEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.salesRepEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.SALEREP_DC_EMAIL_DUPE;
      }
    } else if (
      debiDetails?.debis[0]?.installerEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.salesRepEmail?.toUpperCase()
    ) {
      if (
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.SALEREP_INSTALLER_EMAIL_DUPE;
      }
    }
    setErrorMessages(newErrors);
    setEmailError(newErrors.emailMatch || "");
    return Object.keys(newErrors).length === 0;
  };
  const validateSubmitFields = () => {
    const newErrors = {};
    const mailFormat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const mailMatchDC = mailFormat.test(remainingFields.dcEmail);
    const mailMatchStore = mailFormat.test(remainingFields.storeAgentEmail);
    if (!remainingFields.installerBusinessName) {
      newErrors.installerBusinessName = VALIDATIONS.INSTALLER_NAME_REQUIRED;
    }
    if (!remainingFields.dcName) {
      newErrors.dcName = VALIDATIONS.DC_NAME_REQUIRED;
    } else if (remainingFields.dcName.length > 60) {
      newErrors.dcName = VALIDATIONS.DC_NAME_LENGTH;
    }
    if (!remainingFields.dcEmail) {
      newErrors.dcEmail = VALIDATIONS.DC_EMAIL_REQUIRED;
    } else if (remainingFields.dcEmail.length > 60) {
      newErrors.dcEmail = VALIDATIONS.DC_EMAIL_LENGTH;
    } else if (!mailMatchDC) {
      newErrors.dcEmail = VALIDATIONS.DC_EMAIL_VALID;
    }
    if (!remainingFields.storeAgent) {
      newErrors.storeAgent = VALIDATIONS.STORE_AGENT_REQUIRED;
    } else if (remainingFields.storeAgent.length > 60) {
      newErrors.storeAgent = VALIDATIONS.STORE_AGENT_LENGTH;
    }
    if (!remainingFields.storeAgentEmail) {
      newErrors.storeAgentEmail = VALIDATIONS.STORE_AGENT_EMAIL_REQUIRED;
    } else if (remainingFields.storeAgentEmail.length > 60) {
      newErrors.storeAgentEmail = VALIDATIONS.STORE_AGENT_EMAIL;
    } else if (!mailMatchStore) {
      newErrors.storeAgentEmail = VALIDATIONS.STORE_AGENT_EMAIL_VALID;
    }

    if (
      remainingFields?.storeAgentEmail?.toUpperCase() ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() &&
      remainingFields?.dcEmail ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() &&
      debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        remainingFields?.storeAgentEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch =
          VALIDATIONS.DC_STORE_SALESREP_INSTALLER_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.storeAgentEmail?.toUpperCase() ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() &&
      remainingFields?.dcEmail?.toUpperCase() ===
        debiDetails?.debis[0]?.installerEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        remainingFields?.storeAgentEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.DC_STORE_INSTALLER_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.dcEmail?.toUpperCase() ===
      remainingFields?.storeAgentEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        remainingFields?.storeAgentEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.DC_STORE_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.dcEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.installerEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.DC_INSTALLER_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.storeAgentEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.installerEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.storeAgentEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.STORE_INSTALLER_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.storeAgentEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.salesRepEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.storeAgentEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.SALEREP_STORE_EMAIL_DUPE;
      }
    } else if (
      remainingFields?.dcEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.salesRepEmail?.toUpperCase()
    ) {
      if (
        remainingFields?.dcEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.SALEREP_DC_EMAIL_DUPE;
      }
    } else if (
      debiDetails?.debis[0]?.installerEmail?.toUpperCase() ===
      debiDetails?.debis[0]?.salesRepEmail?.toUpperCase()
    ) {
      if (
        debiDetails?.debis[0]?.installerEmail?.toUpperCase() === "" &&
        debiDetails?.debis[0]?.salesRepEmail?.toUpperCase() === ""
      ) {
      } else {
        newErrors.emailMatch = VALIDATIONS.SALEREP_INSTALLER_EMAIL_DUPE;
      }
    }
    setErrorMessages(newErrors);
    setEmailError(newErrors.emailMatch || "");
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateSignatureFields()) {
      return;
    }
    if (validationMsgs.length > 0) {
      scrollToTop();
      return;
    }
    const payload = {
      id: debiDetails?.debis[0]?.id,
      businessName:debiDetails?.debis[0]?.businessName,
      installerEmail: debiDetails?.debis[0]?.installerEmail,
      installerStreetAddress: debiDetails?.debis[0]?.installerStreetAddress,
      installerCity: debiDetails?.debis[0]?.installerCity,
      installerState: debiDetails?.debis[0]?.installerState,
      dcName: remainingFields?.dcName,
      dcEmail: remainingFields?.dcEmail,
      storeAgentName: remainingFields?.storeAgent,
      storeAgentEmail: remainingFields?.storeAgentEmail,
      installerBusinessName:  remainingFields?.installerBusinessName,
      telephone: debiDetails?.debis[0]?.telephone,
      zipCode: debiDetails?.debis[0]?.zipCode,
      lastUpdatedBy: getUserName(),
    };
    setLoader(true);
    try {
      const response = await updateDebi(payload);
      setMessage(response?.message);
      setTimeout(() => {
        setMessage("");
      }, 3000);
      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };
  const getTotalQty = (partsArray) => {
    const totalQty = partsArray?.reduce(
      (acc, item) => acc + parseInt(item.quantity),
      0
    );
    setTotlaQuantity(parseInt(totalQty));
  };
  const handleParts = async (id, debiRegistrationNumber) => {
    try {
      const results = await Promise.all(
        partRows.map(async (item) => {
          try {
            const req = {
              debiId: id,
              partNumber: item.partNumber,
              quantity: item.quantity,
            };
            const response = await createQuantityPart(req);
            setLoader(false);
            return await response;
          } catch (error) {
            setApiError((val) => ({
              ...val,
              val: true,
              message: error.message,
            }));
            setLoader(false);
          }
        })
      );
      if (results) {
        navigate(`/debi-tool/details/${debiRegistrationNumber}`, {
          state: id,
        });
      }
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };
  const handleRevision = async () => {
    setLoader(true);
    let revNum;
    try {
      revNum = await fetchRevisionNumber(
        debiDetails?.debis[0]?.debiRegistrationNumber
      );
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error?.message }));
      setLoader(false);
    }
    let response;
    setLoader(true);
    const payload = {
      debiRegistrationNumber: debiDetails?.debis[0]?.debiRegistrationNumber,
      distributionCenter: debiDetails?.debis[0]?.distributionCenter,
      store: debiDetails?.debis[0]?.store,
      businessName: debiDetails?.debis[0]?.businessName,
      installerStreetAddress: debiDetails?.debis[0]?.installerStreetAddress,
      installerEmail: debiDetails?.debis[0]?.installerEmail,
      installerCity: debiDetails?.debis[0]?.installerCity,
      installerState: debiDetails?.debis[0]?.installerState,
      telephone: debiDetails?.debis[0]?.telephone,
      zipCode: debiDetails?.debis[0]?.zipCode,
      dealerNumber: debiDetails?.debis[0]?.dealerNumber,
      salesRepEmail: getUserEmail(),
      salesRepName: getUserName(),
      createdBy: getUserName(),
      statusReason: "Incomplete",
      formType: "Revision",
      revisionNumber: revNum,
      storeAgentName: remainingFields?.storeAgent,
      storeAgentEmail: remainingFields?.storeAgentEmail,
      dcName: remainingFields?.dcName,
      dcEmail: remainingFields?.dcEmail,
      installerBusinessName:  remainingFields?.installerBusinessName,
    };
    setLoader(true);
    try {
      response = await createDebi(payload);
      if (response?.id) {
        handleParts(response.id, response.debiDTO?.debiRegistrationNumber);
      }
      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error?.message }));
      setLoader(false);
    }
  };
  const handleSubmit = async () => {
    if (!validateSubmitFields()) {
      return;
    }
    if (validationMsgs.length > 0) {
      scrollToTop();
      return;
    }
    if (totalQuantity <= 0) {
      setQtyErrorMsg(VALIDATIONS.QTY_VALIDATION);
      setApiError((val) => ({
        ...val,
        val: true,
        message: VALIDATIONS.QTY_VALIDATION,
      }));
      return;
    }
    setOpenSubmitDebi(true);
  };
  const handleSubmitApiCall = async () => {
    setLoader(true);
    const payload = {
      id: debiDetails?.debis[0]?.id,
      businessName: debiDetails?.debis[0]?.businessName,
      installerStreetAddress: debiDetails?.debis[0]?.installerStreetAddress,
      installerEmail: debiDetails?.debis[0]?.installerEmail,
      installerCity: debiDetails?.debis[0]?.installerCity,
      installerState: debiDetails?.debis[0]?.installerState,
      dcName: remainingFields?.dcName,
      dcEmail: remainingFields?.dcEmail,
      storeAgentName: remainingFields?.storeAgent,
      storeAgentEmail: remainingFields?.storeAgentEmail,
      installerBusinessName: remainingFields?.installerBusinessName,
      telephone: debiDetails?.debis[0]?.telephone,
      zipCode: debiDetails?.debis[0]?.zipCode,
      lastUpdatedBy: getUserName(),
    };
    try {
      const response = await submitDebi(payload);
      setMessage(response?.message);
      setTimeout(() => {
        setMessage("");
      }, 3000);
      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
    navigate("/debi-tool/home");
  };
  useEffect(() => {
    if (totalQuantity > 0) {
      setQtyErrorMsg("");
      setApiError({ val: false, messages: "" });
    }
  }, [totalQuantity]);

  const delClicked = (data) => {
    setSelectedPart(data?.parts);
    setClickDel(true);
  };
  const updateSelected = (data) => {
    setHeader(UPDATE_PARTS);
    setSelectedDetails(data);
    setOpenPart(true);
  };
  const handleDownload = async () => {
    setLoader(true);
    try {
      const id = state?.craetedebiFlag ? state?.response?.id : state;
      const url = `${process.env.REACT_APP_BASE_URL}/debi/document/download?id=${id}`;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Debi.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };

  const partModied = (data, action, index) => {
    let existData = debiDetails;
    setPartsRows([]);
    if (action === ADD_PARTS && existData?.partDetails) {
      existData?.partDetails.push(data);
    } else if (action === UPDATE_PARTS && existData?.partDetails) {
      existData.partDetails[index] = data;
    } else if (action === DELETE_PART) {
      const deleteItem = existData?.partDetails.filter(
        (item) => item.id !== data.id
      );
      existData.partDetails = deleteItem;
    }
    if (existData) {
      setDebiDetails(existData);
      setTimeout(() => {
        setPartsRows(
          action === ADD_PARTS
            ? existData.partDetails?.reverse()
            : existData.partDetails
        );
        getTotalQty(existData.partDetails);
      }, 100);
    }
  };
  const changeUpdatedValue = (finalData) => {
    if (debiDetails) {
      let tmp = debiDetails;
      tmp.debis[0] = finalData;
      setDebiDetails(tmp);
    } else if (state && state.craetedebiFlag) {
      setDebiDetails(state?.dataToDetails);
    }
  };
  const handleDelete = async () => {
    setLoader(true);
    try {
      await deleteDebi(debiDetails?.debis[0]?.id);
      setLoader(false);
      navigate("/debi-tool/home");
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };

  const handleCancel = async () => {
    setLoader(true);
    try {
      await cancelDebi(debiDetails?.debis[0]?.id);
      setLoader(false);
      navigate("/debi-tool/home");
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };
  const handleEdit = async () => {
    setLoader(true);
    try {
      await editDebi(debiDetails?.debis[0]?.id);
      fetchDetails();
      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };
  const handleDeleteAction = () => {
    setOpenDebiDelete(true);
  };
  const onValidationChange = (val) => {
    setValidationMsgs(val);
  };
  return (
    <>
      <SimpleBackdrop open={loader} />
      {state && isEditable && (
        <DialogView
          from={SOURCE.PARTS}
          testid="addnewparts"
          open={openPart}
          handleClose={() => handleCloseParts()}
          width={isMobile ? "75%" : "43%"}
          maxWidth={"75em!important"}
          heading={header}
          childComponet={
            <AddNewParts
              header={header}
              selectedDetails={selectedDetails}
              partRows={partRows}
              totalQuantity={totalQuantity}
              id={state}
              setOpenPart={setOpenPart}
              updatedPartList={() => {
                setSelectedDetails("");
              }}
              partModied={partModied}
            />
          }
        />
      )}
      <DialogView
        from={SOURCE.PARTS}
        open={clickDel}
        testid="parts-del"
        handleClose={() => handleCloseParts()}
        width={isMobile ? "75%" : "43%"}
        maxWidth={"75em!important"}
        heading={"Delete"}
        childComponet={
          <DeleteFunctionality
            selectedPart={selectedPart}
            testid="del"
            partRows={partRows}
            cancelClicked={() => setClickDel(false)}
            partModied={partModied}
          />
        }
      />
      <DialogView
        from={SOURCE.PARTS}
        open={openDebiDelete}
        testid="debi-delete"
        handleClose={() => setOpenDebiDelete(false)}
        width={isMobile ? "75%" : "43%"}
        maxWidth={"75em!important"}
        heading={"Delete"}
        childComponet={
          <DeleteFunctionality
            testid="del-debi"
            debiDelete={true}
            cancelClicked={() => setOpenDebiDelete(false)}
            deleteClicked={() => handleDelete()}
          />
        }
      />
      <DialogView
        from={SOURCE.PARTS}
        open={openEditDebi}
        testid="cancel-dialog"
        handleClose={() => setOpenEditDebi(false)}
        width={isMobile ? "75%" : "43%"}
        maxWidth={"75em!important"}
        heading={"Edit Debi"}
        childComponet={
          <EditDebi
            testid="edi-debi"
            cancelClicked={() => setOpenEditDebi(false)}
            proceedClicked={() => {
              handleEdit();
              setOpenEditDebi(false);
              setEditClicked(true);
            }}
          />
        }
      />
      <DialogView
        from={SOURCE.PARTS}
        open={openCancelDebi}
        testid="cancel-dialog"
        handleClose={() => setOpenCancelDebi(false)}
        width={isMobile ? "75%" : "43%"}
        maxWidth={"75em!important"}
        heading={"Cancel Debi"}
        childComponet={
          <CancelDebi
            testid="cancel-debi"
            noClicked={() => setOpenCancelDebi(false)}
            yesClicked={() => {
              handleCancel();
              setOpenCancelDebi(false);
            }}
          />
        }
      />
      <DialogView
        from={SOURCE.PARTS}
        open={openSubmitDebi}
        testid="cancel-dialog"
        handleClose={() => setOpenSubmitDebi(false)}
        width={isMobile ? "75%" : "43%"}
        maxWidth={"75em!important"}
        heading={"Submit Debi"}
        childComponet={
          <SubmitDebi
            testid="cancel-debi"
            cancelClicked={() => setOpenSubmitDebi(false)}
            okClicked={() => {
              handleSubmitApiCall();
              setOpenSubmitDebi(false);
            }}
          />
        }
      />
      <DialogView
        from={SOURCE.PARTS}
        open={openReviseDebi}
        testid="cancel-dialog"
        handleClose={() => setOpenReviseDebi(false)}
        width={isMobile ? "75%" : "43%"}
        maxWidth={"75em!important"}
        heading={"Revise Debi"}
        childComponet={
          <ReviseDebi
            testid="cancel-debi"
            cancelClicked={() => setOpenReviseDebi(false)}
            okClicked={() => {
              handleRevision();
              setOpenReviseDebi(false);
            }}
          />
        }
      />

      <Container
        breadCrumb={true}
        activeBreadCrumbLink={DEBI_DETAILS}
        title={DEBI_DETAILS_MSG}
      >
        {/* Installer Info Section*/}
        <AppH5Header text={INSTALLER_MSG} />
        <AppH6Header text={INSTALLER_INFO_MSG} />
        <DebiDetailsInfo
          details={debiDetails}
          changeUpdatedValue={changeUpdatedValue}
          onValidationChange={onValidationChange}
          editClicked={editClicked}
        />
        {/*Add parts section  */}
        <div className="section-bg-gap">
          <AppH5Header text={DEBI_PARTS_MSG} />
          <AppH6Header text={DEBI_ADD_PARTS_MSG} />
          <div className="form-layout">
            <GridContainer>
              <GridItem xs={12} sm={12} lg={12} md={12} xl={12}>
                <div className="flex-container flex-right grid-actions">
                  <ButtonLayout
                    color="primary"
                    label={ADD_PARTS}
                    testid="parts"
                    disabled={
                      !(username === debiDetails?.debis[0]?.createdBy) ||
                      debiDetails?.debis[0]?.statusReason === STATUS.OPEN ||
                      debiDetails?.debis[0]?.statusReason === STATUS.CLOSED ||
                      !(
                        debiDetails?.docusignDetails &&
                        debiDetails?.docusignDetails?.length === 0
                      )
                    }
                    onClickBtn={() => onPressAdd()}
                  />
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} lg={12} md={12} xl={12}>
                {isMobile ? (
                  <DataList
                    source={SOURCE.PARTS}
                    username={username}
                    debiDetails={debiDetails}
                    updateClicked={updateSelected}
                    deleteClicked={delClicked}
                    rows={partRows}
                    isEditable={isEditable}
                  />
                ) : (
                  <DataTable
                    source={SOURCE.PARTS}
                    testid="table"
                    username={username}
                    debiDetails={debiDetails}
                    deleteClicked={delClicked}
                    updateClicked={updateSelected}
                    rows={partRows}
                    isEditable={isEditable}
                  />
                )}
              </GridItem>
            </GridContainer>
          </div>
        </div>
        <div className="section-bg-gap">
          <AppH6Header text={"Total Parts"} />
          <p>{totalQuantity}</p>
          {qtyErrorMsg && <p style={COLOR_RED}>{qtyErrorMsg} </p>}
        </div>
        {/* Agreement and Acceptance */}
        <div className="section-bg-gap">
          <AppH5Header text={DEBI_AGREEMENT_ACCEPTANCE_TEXT} />
          <AppH6Header text={DEBI_AGREEMENT_MSG} />
          <div className="section-gap">
            <AppH6Header text={DEBI_SIGN_MSG} />
            <AgreementInput
              debiDetails={debiDetails}
              testid="agreement-input"
              data={AGREEMENT_INPUT_FORM}
              onChange={(key, value) => handleFieldChange(key, value)}
              installerName={true}
              errorMessages={errorMessages}
              setErrorMessages={setErrorMessages}
              fromInstaller={true}
              editClicked={editClicked}
              username={username}
              remainingFields={remainingFields}
            />
          </div>
        </div>
        {/* Required Signatures */}
        <div className="section-bg-gap">
          <AppH5Header text={DEBI_REQ_SIG} />
          <AppH6Header text={DEBI_REQ_SIG_TEXT} />
          <SignaturesInput
            testid="sign-input"
            username={username}
            debiDetails={debiDetails}
            onChange={(key, value) => handleFieldChange(key, value)}
            remainingFields={remainingFields}
            errorMessages={errorMessages}
            setErrorMessages={setErrorMessages}
            editClicked={editClicked}
          />
          {message && <div style={COLOR_GREEN}>{message}</div>}
          {emailError && <div style={COLOR_RED}>{emailError}</div>}
        </div>
        {/* Approve for Processing */}
        <div className="section-bg-gap">
          <AppH6Header text={DEBI_PROCESS_APPROVE_MSG} />
          <AgreementInput
            debiDetails={debiDetails}
            testid="agree-input"
            data={PROCESSING_INFO}
            onChange={(key, value) => handleFieldChange(key, value)}
            username={debiDetails?.debis && debiDetails?.debis[0]?.createdBy}
            editClicked={editClicked}
            
          />
        </div>
        {/* Notes */}
        <div className="section-bg-gap">
          <div className="form-layout">
            <GridContainer>
              <GridItem xs={12} sm={12} lg={12} md={12} xl={12}>
                <div style={DEBI_DETAILS_GRIDITEN_STYLE}>
                  <div style={DISPLAY_FLEX}>
                    <ButtonLayout
                      color="primary"
                      label="Save Draft"
                      testid="Save Draft"
                      disabled={
                        !(username === debiDetails?.debis[0]?.createdBy) ||
                        debiDetails?.debis[0]?.statusReason === STATUS.OPEN ||
                        debiDetails?.debis[0]?.statusReason === STATUS.CLOSED ||
                        !(
                          debiDetails?.docusignDetails &&
                          debiDetails?.docusignDetails?.length === 0
                        )
                      }
                      onClickBtn={handleUpdate}
                    />{" "}
                    &nbsp; &nbsp;
                    {debiDetails?.debis[0]?.statusReason === "Incomplete" &&
                      debiDetails?.docusignDetails &&
                      debiDetails?.docusignDetails?.length > 0 && (
                        <ButtonLayout
                          color="primary"
                          label={EDIT}
                          testid="parts"
                          disabled={
                            !(username === debiDetails?.debis[0]?.createdBy)
                          }
                          onClickBtn={() => setOpenEditDebi(true)}
                        />
                      )}
                    &nbsp; &nbsp;
                    {!isMobile &&
                      debiDetails?.debis[0]?.statusReason === STATUS.OPEN && (
                        <>
                          <ButtonLayout
                            color="primary"
                            label="Cancel"
                            testid="cancel"
                            disabled={
                              !(username === debiDetails?.debis[0]?.createdBy)
                            }
                            onClickBtn={() => {
                              setOpenCancelDebi(true);
                            }}
                          />{" "}
                          &nbsp; &nbsp;
                          <ButtonLayout
                            color="primary"
                            label="Revise"
                            testid="revision1"
                            disabled={
                              !(username === debiDetails?.debis[0]?.createdBy)
                            }
                            onClickBtn={() => {
                              setOpenReviseDebi(true);
                            }}
                          />
                        </>
                      )}
                    &nbsp; &nbsp;
                    {!isMobile && (
                      <ButtonLayout
                        testid="submit"
                        color="primary"
                        label="Submit"
                        disabled={
                          !(username === debiDetails?.debis[0]?.createdBy) ||
                          debiDetails?.debis[0]?.statusReason === STATUS.OPEN ||
                          debiDetails?.debis[0]?.statusReason ===
                            STATUS.CLOSED ||
                          !(
                            debiDetails?.docusignDetails &&
                            debiDetails?.docusignDetails?.length === 0
                          )
                        }
                        onClickBtn={handleSubmit}
                      />
                    )}
                  </div>
                  <div style={DISPLAY_FLEX}>
                    <ButtonLayout
                      color="primary"
                      label="Delete"
                      testid="Delete"
                      disabled={
                        !(username === debiDetails?.debis[0]?.createdBy) ||
                        debiDetails?.debis[0]?.statusReason === STATUS.OPEN ||
                        debiDetails?.debis[0]?.statusReason === STATUS.CLOSED ||
                        !(
                          debiDetails?.docusignDetails &&
                          debiDetails?.docusignDetails?.length === 0
                        )
                      }
                      onClickBtn={handleDeleteAction}
                    />{" "}
                    &nbsp; &nbsp;
                    <ButtonLayout
                      color="primary"
                      testid="download"
                      label="Download"
                      disabled={!isAdmin}
                      onClickBtn={handleDownload}
                    />{" "}
                    &nbsp;
                  </div>
                </div>
                {isMobile &&
                  debiDetails?.debis[0]?.statusReason === STATUS.OPEN && (
                    <>
                      <ButtonLayout
                        testid="cancel1"
                        color="primary"
                        label="Cancel"
                        sx={{ width: "48%", marginTop: "10px" }}
                        disabled={
                          !(username === debiDetails?.debis[0]?.createdBy)
                        }
                        onClickBtn={() => {
                          setOpenCancelDebi(true);
                        }}
                      />
                      <ButtonLayout
                        testid="revision"
                        color="primary"
                        label="Revise"
                        sx={{
                          width: "48%",
                          marginTop: "10px",
                          marginLeft: "10px",
                        }}
                        disabled={
                          !(username === debiDetails?.debis[0]?.createdBy)
                        }
                        onClickBtn={() => {
                          setOpenReviseDebi(true);
                        }}
                      />
                    </>
                  )}
                {isMobile && (
                  <ButtonLayout
                    testid="submit"
                    color="primary"
                    label="Submit"
                    sx={{ width: "100%", marginTop: "10px" }}
                    disabled={
                      !(username === debiDetails?.debis[0]?.createdBy) ||
                      debiDetails?.debis[0]?.statusReason === STATUS.OPEN ||
                      debiDetails?.debis[0]?.statusReason === STATUS.CLOSED ||
                      !(
                        debiDetails?.docusignDetails &&
                        debiDetails?.docusignDetails?.length === 0
                      )
                    }
                    onClickBtn={handleSubmit}
                  />
                )}
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </Container>
      <SimpleSnackbar apiError={apiError} />
    </>
  );
};

export default DebiDetails;
